import React from "react";
import {GET_CONTEST_INFO} from "../../../../../AdminPart/GraphQL/queries/OnlyHereQueries";
import {useQuery} from "@apollo/client";
import {MonthToText} from "../../../../../AdminPart/src/Constants";
import TextChange from "../../../../../AdminPart/src/Elements/TextChange/TextChange";

function QueryContestInfo (props) {
    function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
    } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

    const { loading, error, data} = useQuery(GET_CONTEST_INFO, {variables : { Name : 'DailyBitcoin' }});
    if (loading) return 'loading...';
    if (error) return `loading error! ${error.message}`;
    return (
        <div className="DailyBitcoinTopDateTime">
            <div className="DailyBitcoinTopDateTimeElement">
                <div className="DailyBitcoinTopDateTimeElementTitle"><TextSource ArrIndex= 'DailyBitcoin0033'>Дата проведения конкурса</TextSource>  </div>
                <div className="DailyBitcoinTopDateTimeElementText"> {data.getGlobalVariable.DopInfo.split('-')[2] + ' ' + MonthToText(data.getGlobalVariable.DopInfo.split('-')[1],props.lang)  + ' ' + data.getGlobalVariable.DopInfo.split('-')[0]}</div>

            </div>
        </div>
    )}
export default QueryContestInfo